<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
  <div class="grid-gallery">
    <div class="gg-images">
      <grid-image
        v-for="(image, index) in fields.images"
        :fields="image.fields"
        :key="index"
      />
    </div>
    <div v-if="hasCredits(fields) || isEditMode" class="gg-credit">
      <sc-rich-text :field="fields.credit || {}" tag="p"/>
      <sc-rich-text :field="fields.collaboration || {}" tag="p"/>
    </div>
  </div>
  </sc-render>
</template>

<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue'
import { createNamespacedHelpers } from 'vuex'
import isEmptyObject from '~/helpers/is-empty-object'
import GridImage from '../grid-gallery-image'
import ScRender from '../sc-render/'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'GridGallery',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScRichText: RichText,
    GridImage,
    ScRender
  },
  computed: {
    ...mapJssGetters(['isEditMode']),
    isEmpty () {
      return isEmptyObject(this.fields)
    }
  },
  methods: {
    hasCredits (fields) {
      const { credit } = fields
      const { collaboration } = fields
      return !!((credit && credit.value)
        || (collaboration && collaboration.value))
    }
  }
}
</script>

<style lang="scss" scoped>

.grid-gallery {
  text-align: center;
  padding: 0 6.7%;
  margin-bottom: $space-080;

  @include tablet {
    padding: 0 7%;
    margin-bottom: $space-090;
  }

  @include desktop {
    padding: 0 4.4%;
  }
}

.gg-images {
  display: inline-block;
  max-width: 1368px;
}

.gg-credit {
  p {
    @include font('060');
    margin: 0;
    font-style: italic;
    text-align: right;
    color: $color-slate-dark;
  }
}

</style>
